import { WebSocketService } from './../../modules/services/websocket.service';
import { NumberFormatPipe } from '../../modules/pipe/number-format.pipe';
import { switchMap, startWith } from 'rxjs/operators';
import { PublicReportService } from '../../modules/services/public-report.service';
import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { ChartDataSets, ChartLegendItem, ChartOptions, ChartType, Chart } from 'chart.js';
import * as _ from 'lodash';
import * as _moment from 'moment';
const moment = _moment;
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
// import { Console } from 'console';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';
import { saveAs } from 'file-saver';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HeatmapBubbleComponent } from '../heatmap-bubble/heatmap-bubble.component';
@Component({
  selector: 'app-new-main-dashboard',
  templateUrl: './new-main-dashboard.component.html',
  styleUrls: ['./new-main-dashboard.component.scss']
})
export class NewMainDashboardComponent implements OnInit {
  @ViewChild(HeatmapBubbleComponent) Heatmap: HeatmapBubbleComponent;
  @Output() clickevent = new EventEmitter();
  selectedTabLabel = '';
  headerTextLbl = 'State';
  state_id;
  district_id;
  todaysdate;
  reportData;
  ReportGenerateTime;
  topBlockReport;
  liveVaccData
  vaccinatedAefiPer;
  lineChartDataNew;
  realTimeChart;
  isday = true;
  ismonth = false;
  isweek;
  isByAge;
  isByDoses = true;
  realTimeChartlast30days;
  last30DaysVaccinationData;
  weeklyReportData;
  realTimeChartweek;
  isdayVaccAge = false;
  ismonthVaccAge = false;
  isweekVaccAge = false;
  vaccinationAgeDataToday;
  vaccinationAgeChartToday;
  vaccinationAgeChartMonth;
  vaccinationAgeDataMonth;
  vaccinationAgeDataAll;
  vaccinationAgeChartAll;
  liveVaccinationCounter: any;
  webSocketCounter: any;
  totalVaccinationCounter: any = 0;
  partialVaccinationCounter: any = 0;
  fullyVaccinationCounter: any = 0;
  totalRegistrationCounter: any = 0;
  intervalSub$: Subscription = new Subscription();
  hideWebSocketCounter = true;
  suffix = 'IND';
  liveVaccChart;
  liveVaccChartStreaming;
  prevsData;
  updateCountTotalVacc = 0;
  liveVaccChartStreamingRegistration;
  prevsRegData;
  updateCountTotalReg = 0;
  liveVaccChartStreamingPartialVacc;
  prevsPartialVaccData;
  updateCountPartialVacc = 0;
  liveVaccChartStreamingFullyVacc;
  prevsFullyVaccData;
  updateCountFullyVacc = 0;
  updateInterval = 300;
  numberOfElements = 10;
  options: any = {
    useGrouping: false,
    formattingFn: (n: number) => n.toLocaleString('en-IN')
  }
  vaccinationByAgeChart;
  vaccinationByAgeChartData;
  genderVaccPieChart;
  materialVaccPieChart;
  materialVaccPieChartnew;
  genderVaccPieChartNew;
  vaccinationByAgeChartNew;
  states;
  // districtListfromstate = [];
  // districtList;
  stateId;
  district;
  chartFlag;
  registartionChartDataMonth: any;
  isdayReg: boolean;
  ismonthReg: boolean;
  isweekReg: boolean;
  registartionChartMonth: any;
  registartionChartDataAll: any;
  registartionChartAll: any;
  registartionChart: any;
  registartionChartData: any;
  isdayVacc: boolean;
  ismonthVacc: boolean;
  isweekVacc: boolean;
  vaccinationAEFIChart: any;
  vaccinationAEFIChartData: any;
  vaccinationByCategoryChart: any;
  vaccinationByCategoryData: any;
  secondHalf: any;
  getVaccinationByStateUTData: any;
  doughnutChartForTable: any;
  chartStateId: any;
  chartDose_1: any;
  chartDose_2: any;
  chartTotal: any;
  dynamicId: string;
  charts = [];
  semesters: number[];
  stateArr: any;
  dose_1: any;
  // states: { state_id: number; state_code: string; state_name: string; }[];
  districtListfromstate: any;
  districtList: any;
  collapseId: any;
  iconClass: boolean = false;
  hideShowFilter: boolean = false;
  FilterIcon: boolean = false;
  districtListnew;
session_site_id
  hideShowExport: boolean;
  isState: string;
  isDistrict: string;
  DownlloadVaccinationDoneByTime: any;
  DownlloadVaccinationDoneByTimeAgeWise: any;
  DownlloadImeWiseTodayRegReport: any;
  DownlloadLast30DaysAefi: any;
  DownlloadVaccinationByAge: any;
  Downloadlast30DaysVaccination: any;
  DownloadweeklyReport: any;
  Downloadlast30DaysAgeWiseVaccination: any;
  DownloadweeklyVacAgeWiseReport: any;
  DownloadRegReportData: any;
  DownloadRegWeekReportData: any;
  getBeneficiariesGroupBy: any;
  vaccinationByAgefinalResult: any = [];
  downloadExcelHeader;
  downloadExcelHeaderForCoverage: string;
  vaccinationCoverageByStateChartData: any;
  tableheader: any;
  exportIcon: boolean;
  statename;
  total12_14Vaccination: any = 0;
  total15_17Vaccination: any = 0;
total18_44Vaccination: any = 0;
total45_60Vaccination: any = 0;
totalabove_60Vaccination: any = 0;
total_hcw_flw_precaution_vaccinations: any = 0;
total_60_plus_precaution_vaccinations: any = 0;
statedistrict:any;
  constructor(private publicReportService: PublicReportService,
    public deviceService: DeviceDetectorService,
    public datepipe: DatePipe,
    public numberFormatPipe: NumberFormatPipe,
    private translate: TranslateService,
    private webSocket: WebSocketService) { }

  ngOnInit(): void {
    this.todaysdate = new Date();
    this.todaysdate = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
    this.states = [
      {
        "state_id": 1,
        "state_code": "AN",
        "state_name": "Andaman and Nicobar Islands"
      },
      {
        "state_id": 2,
        "state_code": "AP",
        "state_name": "Andhra Pradesh"
      },
      {
        "state_id": 3,
        "state_code": "AR",
        "state_name": "Arunachal Pradesh",

      },
      {
        "state_id": 4,
        "state_code": "AS",
        "state_name": "Assam"
      },
      {
        "state_id": 5,
        "state_code": "BR",
        "state_name": "Bihar"
      },
      {
        "state_id": 6,
        "state_code": "CH",
        "state_name": "Chandigarh"
      },
      {
        "state_id": 7,
        "state_code": "CG",
        "state_name": "Chhattisgarh"
      },
      {
        "state_id": 8,
        "state_code": "DH",
        "state_name": "Dadra and Nagar Haveli"
      },
      {
        "state_id": 37,
        "state_code": "DD",
        "state_name": "Daman and Diu"
      },
      {
        "state_id": 9,
        "state_code": "DL",
        "state_name": "Delhi"
      },
      {
        "state_id": 10,
        "state_code": "GA",
        "state_name": "Goa"
      },
      {
        "state_id": 11,
        "state_code": "GJ",
        "state_name": "Gujarat"
      },
      {
        "state_id": 12,
        "state_code": "HR",
        "state_name": "Haryana"
      },
      {
        "state_id": 13,
        "state_code": "HP",
        "state_name": "Himachal Pradesh"
      },
      {
        "state_id": 14,
        "state_code": "JK",
        "state_name": "Jammu and Kashmir"
      },
      {
        "state_id": 15,
        "state_code": "JH",
        "state_name": "Jharkhand"
      },
      {
        "state_id": 16,
        "state_code": "KA",
        "state_name": "Karnataka"
      },
      {
        "state_id": 17,
        "state_code": "KL",
        "state_name": "Kerala"
      },
      {
        "state_id": 18,
        "state_code": "LA",
        "state_name": "Ladakh"
      },
      {
        "state_id": 19,
        "state_code": "LD",
        "state_name": "Lakshadweep"
      },
      {
        "state_id": 20,
        "state_code": "MP",
        "state_name": "Madhya Pradesh"
      },
      {
        "state_id": 21,
        "state_code": "MH",
        "state_name": "Maharashtra"
      },
      {
        "state_id": 22,
        "state_code": "MN",
        "state_name": "Manipur"
      },
      {
        "state_id": 23,
        "state_code": "ML",
        "state_name": "Meghalaya"
      },
      {
        "state_id": 24,
        "state_code": "MZ",
        "state_name": "Mizoram"
      },
      {
        "state_id": 25,
        "state_code": "NL",
        "state_name": "Nagaland"
      },
      {
        "state_id": 26,
        "state_code": "OD",
        "state_name": "Odisha"
      },
      {
        "state_id": 27,
        "state_code": "PY",
        "state_name": "Puducherry"
      },
      {
        "state_id": 28,
        "state_code": "PB",
        "state_name": "Punjab"
      },
      {
        "state_id": 29,
        "state_code": "RJ",
        "state_name": "Rajasthan"
      },
      {
        "state_id": 30,
        "state_code": "SK",
        "state_name": "Sikkim"
      },
      {
        "state_id": 31,
        "state_code": "TN",
        "state_name": "Tamil Nadu"
      },
      {
        "state_id": 32,
        "state_code": "TS",
        "state_name": "Telangana"
      },
      {
        "state_id": 33,
        "state_code": "TR",
        "state_name": "Tripura"
      },
      {
        "state_id": 34,
        "state_code": "UP",
        "state_name": "Uttar Pradesh"
      },
      {
        "state_id": 35,
        "state_code": "UK",
        "state_name": "Uttarakhand"
      },
      {
        "state_id": 36,
        "state_code": "WB",
        "state_name": "West Bengal"
      }

    ]
    this.getLiveVaccinationCounter();
    // this.getDataForLiveVaccCountChart();
    // setTimeout(() => {
    //   this.prepareDataForLiveVaccStareaming();
    //   this.prepareDataForLiveVaccStareamingRegistration();
    //   this.prepareDataForLiveVaccStareamingPartialVacc();
    //   this.prepareDataForLiveVaccStareamingFullyVacc();
    //   this.getDistrictList()

    // }, 1)

    setTimeout(() => {
      this.prepareDataForLiveVaccStareaming();
      this.prepareDataForLiveVaccStareamingRegistration();
      this.prepareDataForLiveVaccStareamingPartialVacc();
      this.prepareDataForLiveVaccStareamingFullyVacc();
      this.getDistrictList()
      this.prepareDataForLiveVaccStareaming12_14();
      this.prepareDataForLiveVaccStareaming15_17();
      this.prepareDataForLiveVaccStareaming18_44();
      this.prepareDataForLiveVaccStareaming45_60();
      // this.prepareDataForLiveVaccStareamingabove_60();
      this.updateDataAge();
    }, 1)


  }

  getDashboardData(state_id = "", district_id = "") {
    this.state_id = state_id;
    this.district_id = district_id
    console.log("")
    if (district_id == '' || district_id == undefined) {
      this.getDistrictID(state_id);
    }
    this.chartFlag = (district_id) ? true : false;
    // this.getVacChartData();

    this.publicReportService.getPublicReports(state_id, district_id, this.todaysdate).subscribe(res => {
      this.reportData = res;
      this.ReportGenerateTime = res.timestamp;
      this.ReportGenerateTime = moment(this.ReportGenerateTime).format('yyyy/MM/DD hh:mm a')
      this.topBlockReport = res.topBlock;
      console.log(this.topBlockReport);
      this.liveVaccData = res.vaccinationDoneByTime;
      this.vaccinatedAefiPer = res.aefiPercentage;
      this.lineChartDataNew = res.vaccinationDoneByTime;
      this.vaccinationAgeDataToday = res.vaccinationDoneByTimeAgeWise;
      this.vaccinationByAgeChartData = res.vaccinationByAge;
      this.registartionChartData = res.timeWiseTodayRegReport;
      this.vaccinationAEFIChartData = res.last30DaysAefi;
      // this.getVaccinationByStateUTData = _.orderBy(res.getBeneficiariesGroupBy, 'total',
      // 'desc');
      this.getVaccinationByStateUTData = res.getBeneficiariesGroupBy;

      this.DownlloadVaccinationDoneByTime = res.vaccinationDoneByTime;
      this.DownlloadVaccinationDoneByTimeAgeWise = res.vaccinationDoneByTimeAgeWise;
      this.DownlloadImeWiseTodayRegReport = res.timeWiseTodayRegReport;
      this.DownlloadLast30DaysAefi = res.last30DaysAefi;
      this.DownlloadVaccinationByAge = res.vaccinationByAge;
      this.getBeneficiariesGroupBy = _.orderBy(res.getBeneficiariesGroupBy, 'total',
      'desc');


      // this.isday = true;
      // this.ismonth = false;
      // this.isweek = false;
      // this.isdayVaccAge = true;
      // this.isweekVaccAge = false;
      // this.ismonthVaccAge = false
      if (this.isday == true) {
        this.prepareDataForVaccByDosesToday()
      }

      // this.loadVaccinationByAgeChart();
      // this.prepareDataForDoughnutChartGender();
      // this.prepareDataForDoughnutChartVaccType();
      this.prepareDataForDoughnutChartVaccTypeNew();
      this.prepareDataForPieChartGenderNew();
      this.loadVaccinationByAgeChartnew();
      if (res.timeWiseTodayRegReport) {
        this.prepareDataForRegChart();
      }

      this.isdayReg = true;
      this.loadVaccinationAEFIChart();
      this.semesters = _.map(this.getVaccinationByStateUTData, 'state_id');
      setTimeout(() => {
        // this.prepareDataForDoughnutChartForTable();

      }, 1)
      if(this.state_id == '' && district_id == '' ){
        this.Heatmap.getStatename("");
      }

      if (this.state_id === '' && this.district_id === '') {
        // this.tableheader = " State/UT";
        // this.ChartHeading = "Top States by Capacity Utilization"
        this.downloadExcelHeader = "StateWiseVaccination"
        this.downloadExcelHeaderForCoverage = "StateWiseVaccinationCoverage"
      } else if (this.state_id != '' && this.district_id == '') {
        // this.tableheader = " Districts";
        // this.ChartHeading = "Top Districts by Capacity Utilization"
        this.downloadExcelHeader = "DistrictWiseVaccination"
        this.downloadExcelHeaderForCoverage = "DistrictWiseVaccinationCoverage"
      } else if (this.state_id != '' && this.district_id != '') {
        // this.tableheader = " Centers";
        // this.ChartHeading = "Top Centers by Capacity Utilization"
        this.downloadExcelHeader = "CenterWiseVaccination"
        this.downloadExcelHeaderForCoverage = "CenterWiseVaccinationCoverage"
      } else {
        // this.tableheader = " State/UT";
        // this.ChartHeading = "Top States by Capacity Utilization"
        this.downloadExcelHeader = "StateWiseVaccination"
        this.downloadExcelHeaderForCoverage = "StateWiseVaccinationCoverage"
      }


    })
  }

  getVacChartData(value = "") {
    this.publicReportService.getVacPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.last30DaysVaccinationData = res.last30DaysVaccination;
        this.weeklyReportData = res.weeklyReport;
        this.vaccinationAgeDataMonth = res.last30DaysAgeWiseVaccination;

        this.Downloadlast30DaysVaccination = res.last30DaysVaccination;
        this.DownloadweeklyReport = res.weeklyReport;
        this.Downloadlast30DaysAgeWiseVaccination = res.last30DaysAgeWiseVaccination;
        this.DownloadweeklyVacAgeWiseReport = res.weeklyVacAgeWiseReport;
        this.DownloadRegReportData = res.regReportData;
        this.DownloadRegWeekReportData = res.regWeekReportData;

        if (this.last30DaysVaccinationData.length) {
          this.prepareDataForVaccByDosesMonth();
        }
        this.vaccinationByCategoryData = [];
        this.secondHalf = [];
        this.vaccinationByCategoryData = res.last30DaysVaccination;

        if (this.vaccinationByCategoryData.length) {
          const half = Math.ceil(this.vaccinationByCategoryData.length / 2);
          this.secondHalf = this.vaccinationByCategoryData.slice(-half);
          this.vaccinationByCategoryData = this.secondHalf;
          this.prepareDataForVaccinationByCategory();
        }
        if (value == "Last 30 Days") {
          this.isByDoses = true;
          this.isday = false;
          this.ismonth = true;
          this.isweek = false;
        }
        if (value == "All") {
          if (this.weeklyReportData.length) {
            this.prepareDataForVaccByDosesAll();
          }
          this.isday = false;
          this.ismonth = false;
          this.isweek = true;
          this.isdayVaccAge = false;
          this.isweekVaccAge = false;
          this.ismonthVaccAge = false
        }
      }
    });

  }

  getVaccChartAgewiseDataMonth(value = "") {

    this.publicReportService.getVacPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.vaccinationAgeDataMonth = res.last30DaysAgeWiseVaccination;
        // console.log("this.vaccinationAgeTodayData", this.vaccinationAgeDataMonth)
        if (this.vaccinationAgeDataMonth.length) {
          this.prepareDataForVaccAgewiseLast30Days();
        }

        if (value == "Last 30 Days") {
          this.isByAge = true;
          this.isByDoses = false;
          this.isdayVaccAge = false;
          this.ismonthVaccAge = true;
          this.isweekVaccAge = false;
          this.isday = false;
          this.ismonth = false;
          this.isweek = false;
        }
      }
    });
  }

  getVaccChartAgewiseDataAll(value = "") {

    this.publicReportService.getVacPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.vaccinationAgeDataAll = res.weeklyVacAgeWiseReport;
        // console.log("this.vaccinationAgeDataAll", this.vaccinationAgeDataAll)
        if (this.vaccinationAgeDataAll.length) {
          this.prepareDataForVaccAgewiseAll();
        }

        if (value == "All") {
          this.isByAge = true;
          this.isByDoses = false;
          this.isdayVaccAge = false;
          this.ismonthVaccAge = false;
          this.isweekVaccAge = true;
          this.isday = false;
          this.ismonth = false;
          this.isweek = false;

        }
      }
    });
  }
  getVaccChartAgewiseDataToday(value = "") {

    this.publicReportService.getPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.vaccinationAgeDataToday = res.vaccinationDoneByTimeAgeWise;

        if (this.vaccinationAgeDataToday.length) {
          this.prepareDataForVaccAgewiseToday();
        }

        if (value == "Today") {
          this.isByAge = true;
          this.isByDoses = false;
          this.isdayVaccAge = true;
          this.ismonthVaccAge = false;
          this.isweekVaccAge = false;
          this.isday = false;
          this.ismonth = false;
          this.isweek = false;

        }
      }
    });
  }

  delay(time) {
    return new Promise((resolve) => {

      setTimeout(() => {

        resolve(true)

      }, time);

    })

  }
  getVaccByTab(tabName = '') {

    if (tabName == 'By Doses') {
      this.isByAge = false;
      this.isByDoses = true;
      this.isday = true;
      this.ismonth = false;
      this.isweek = false;
      this.isdayVaccAge = false;
      this.ismonthVaccAge = false;
      this.isweekVaccAge = false;
    }
    else if (tabName == 'Today') {
      this.isByAge = false;
      this.isByDoses = true;
      this.isday = true;
      this.ismonth = false;
      this.isweek = false;
      this.isdayVaccAge = false;
      this.ismonthVaccAge = false;
      this.isweekVaccAge = false;
    }
    else if (tabName == "By Age") {
      this.isByAge = true;
      this.isByDoses = false;
      this.isday = false;
      this.ismonth = false;
      this.isweek = false;
      this.isdayVaccAge = true;
      this.ismonthVaccAge = false;
      this.isweekVaccAge = false;
      this.prepareDataForVaccAgewiseToday();


    }
    else if (tabName == 'isdayReg') {
      this.isByAge = false;
      this.isByDoses = true;
      this.isdayVacc = false;
      this.ismonthVacc = false;
      this.isweekVacc = false;
      this.isday = true;
      this.ismonth = false;
      this.isweek = false;
      this.isdayReg = true;
      this.ismonthReg = false;
      this.isweekReg = false;
    }



  }

  async prepareDataForVaccByDosesToday() {
    await this.delay(300);
    let draw = Chart.controllers.line.prototype.draw;

    Chart.controllers.line = Chart.controllers.line.extend({
        draw: function() {
             let ctx = this.chart.chart.ctx;
            ctx.save();
            ctx.shadowColor = 'rgb(32 33 36 / 25%)';
            ctx.shadowBlur = 10;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 4;
            ctx.stroke();
                       draw.apply(this, arguments);
            ctx.restore();
        }
    });

    if (this.realTimeChart) {
      this.realTimeChart.destroy();
    }
    const ctx = $('#realtime');
    // var originalStroke = ctx.stroke;
    // ctx.stroke = function () {
    //   ctx.save();
    //   ctx.shadowColor = '#F54394';
    //   ctx.shadowBlur = 10;
    //   ctx.shadowOffsetX = 8;
    //   ctx.shadowOffsetY = 8;
    //   originalStroke.apply(this, arguments)
    //   ctx.restore();
    // }

    if (this.lineChartDataNew) {
      this.lineChartDataNew = this.lineChartDataNew.sort((a, b) => (a.timestamps > b.timestamps) ? 1 : -1)
    }
    const labels = _.map(this.lineChartDataNew, (data) => {
      return moment(data.timestamps, "YYYY-MM-DDTHH:mm:ssZ").subtract(330, "minutes").format('HH:mm');
    });
    //console.log("lable",labels )
    const data1 = _.map(this.lineChartDataNew, 'count');
    const data2 = _.map(this.lineChartDataNew, 'dose_one');
    const data3 = _.map(this.lineChartDataNew, 'dose_two');
    const data4 = _.map(this.lineChartDataNew, 'dose_pd');
    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Total_Doses'),
            backgroundColor: 'rgb(245, 67, 148, 0.1)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(245, 67, 148)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data1,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_One'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: '#ff9800',
            borderWidth: 2,
            pointBackgroundColor: '#ff9800',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_Two'),
            backgroundColor: 'rgb(84, 57, 252, 0.05)',
            borderColor: '#21cc98',
            borderWidth: 2,
            pointBackgroundColor: '#21cc98',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: 'Precaution Dose',
            backgroundColor: 'rgb(33, 204, 152, 0.05)', // 84, 57, 252
            borderColor: '#12ad06',
            borderWidth: 2,
            pointBackgroundColor: '#12ad06',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.realTimeChart = new Chart(ctx, vaccConfig);
    this.realTimeChart.update();
  }

  async prepareDataForVaccByDosesMonth() {

    await this.delay(300);
    if (this.realTimeChartlast30days) {
      this.realTimeChartlast30days.destroy();
    }


    const ctx = $('#realtimemonth');

    if (this.last30DaysVaccinationData) {
      this.last30DaysVaccinationData = this.last30DaysVaccinationData.sort((a, b) => (a.vaccine_date > b.vaccine_date) ? 1 : -1)
    }

    const labels = this.last30DaysVaccinationData.map(obj => moment(obj.vaccine_date, "YYYY-MM-DD").format('DD MMM'));

    const data1 = _.map(this.last30DaysVaccinationData, 'total');
    const data2 = _.map(this.last30DaysVaccinationData, 'dose_1');
    const data3 = _.map(this.last30DaysVaccinationData, 'dose_2');
    const data4 = _.map(this.last30DaysVaccinationData, 'dose_pd');
    const format = this.numberFormatPipe;
    var vaccConfigmonth = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Total_Doses'),
            backgroundColor: 'rgb(245, 67, 148, 0.1)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(245, 67, 148)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data1,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_One'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: '#ff9800',
            borderWidth: 2,
            pointBackgroundColor: '#ff9800',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_Two'),
            backgroundColor: 'rgb(84, 57, 252, 0.05)',
            borderColor: '#21cc98',
            borderWidth: 2,
            pointBackgroundColor: '#21cc98',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: 'Precaution Dose',
            backgroundColor: 'rgb(33, 204, 152, 0.05)', // 84, 57, 252
            borderColor: '#12ad06',
            borderWidth: 2,
            pointBackgroundColor: '#12ad06',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            }

          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.realTimeChartlast30days = new Chart(ctx, vaccConfigmonth);
    this.realTimeChartlast30days.update();

  }

  async prepareDataForVaccByDosesAll() {

    await this.delay(300);
    if (this.realTimeChartweek) {
      this.realTimeChartweek.destroy();
    }


    const ctx = $('#realtimeweek');


    // console.log("this.lineChartDataweek", this.weeklyReportData)
    const labels = this.weeklyReportData.map(obj => obj.label);


    // console.log("lable", labels)

    const data1 = _.map(this.weeklyReportData, 'total');
    const data2 = _.map(this.weeklyReportData, 'dose1');
    const data3 = _.map(this.weeklyReportData, 'dose2');
    const data4 = _.map(this.weeklyReportData, 'dose_pd');
    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Total_Doses'),
            backgroundColor: 'rgb(245, 67, 148, 0.1)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(245, 67, 148)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data1,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_One'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: '#ff9800',
            borderWidth: 2,
            pointBackgroundColor: '#ff9800',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Dose_Two'),
            backgroundColor: 'rgb(84, 57, 252, 0.05)',
            borderColor: '#21cc98',
            borderWidth: 2,
            pointBackgroundColor: '#21cc98',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: 'Precaution Dose',
            backgroundColor: 'rgb(33, 204, 152, 0.05)', // 84, 57, 252
            borderColor: '#12ad06',
            borderWidth: 2,
            pointBackgroundColor: '#12ad06',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },

          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.realTimeChartweek = new Chart(ctx, vaccConfig);
    this.realTimeChartweek.update();

  }

  getDistrictList() {

    this.publicReportService.getDistricts().subscribe((dist) => {
      this.states = this.states.map(res => {
        this.collapseId = res.state_id;
        // console.log("cccc", this.collapseId);
        // this.districtListnew = res
        // this.districtListfromstate = this.districtListnew.filter(e => e.state_id ==  this.collapseId );
        res['districtList'] = dist.filter(d => d.state_id == res.state_id);
        return res;
      })
    });



  }

  iconChange(item){
    this.iconClass = this.iconClass === item ? !this.iconClass : item;
      // this.loadDataByStateTab();
  }
  closeFilter() {
    // $('#myDropdown').css('top', 4 * ($(window).scrollTop() / 5));


    this.hideShowFilter = !this.hideShowFilter;
    this.FilterIcon = !this.FilterIcon;
    if(this.hideShowExport){
      this.hideShowExport = false;
    }
    if(this.exportIcon){
      this.exportIcon = false;
    }
  }
  exportDashboard(){
    this.hideShowExport = !this.hideShowExport;
    this.exportIcon = !this.exportIcon;
    if(this.hideShowFilter){
      this.hideShowFilter = false;
    }
    if(this.FilterIcon){
      this.FilterIcon = false;
    }
  }

  ExportDashboardDataInJson(){
    let key = "";
    if(this.state_id !="" && !this.district_id){
      key = "districtWiseVaccination";
    }
    else if(this.state_id !="" && this.district_id != ""){
      key = "centerWiseVaccination";
    }
    else if(!this.district_id && !this.state_id){
      key = "stateWiseVaccination";
    }

    let jsonDashboardData: object = {
      "vaccinationDoneByTimeToday": this.DownlloadVaccinationDoneByTime,
      "last30DaysVaccination": this.Downloadlast30DaysVaccination,
      "weeklyVaccination": this.DownloadweeklyReport,
      "vaccinationDoneByTimeAgeWiseToday": this.DownlloadVaccinationDoneByTimeAgeWise,
      "last30DaysAgeWiseVaccination": this.Downloadlast30DaysAgeWiseVaccination,
      "weeklyAgeWiseVaccination": this.DownloadweeklyVacAgeWiseReport,
      "registrationDoneByTimeToday": this.DownlloadImeWiseTodayRegReport,
      "last30DaysRegistration": this.DownloadRegReportData,
      "weeklyRegistration": this.DownloadRegWeekReportData,
      "last30DaysAefiReported": this.DownlloadLast30DaysAefi,
      "vaccinationByAge": this.DownlloadVaccinationByAge
    };
    jsonDashboardData[key] = this.getBeneficiariesGroupBy;
    // jsonDashboardData["stateWiseVaccination"] = this.getBeneficiariesGroupBy;
    const blob = new Blob([JSON.stringify(jsonDashboardData)], {type : 'application/json'});
    saveAs(blob, 'dashboard_export.json');
  }
  ExportDashboardDataInExcel(){

  const header = ['label', 'dose_one', 'dose_two','Precaution Dose','count'];
  /**************DownloadVaccinationByDoses Today**************/
  const exportdataByDoseToday = [];
  if (this.DownlloadVaccinationDoneByTime) {
    this.DownlloadVaccinationDoneByTime.forEach(element => {
      exportdataByDoseToday.push([element.label,element.dose_one,element.dose_two,element.dose_pd,element.count])

    });
  }
  const workbook = new Excel.Workbook();
  const worksheet1 = workbook.addWorksheet('VaccinationDoneByTimeToday');
  const headerRow = worksheet1.addRow(header);
  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' },
      bgColor: { argb: 'D3D3D3' }
    };

    cell.font = {
      name: 'Calibri',
      bold: true,
      color: { argb: '000000' }
    };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' };


  exportdataByDoseToday.forEach(d => {
  const row = worksheet1.addRow(d);
});
worksheet1.getColumn(1).width = 20;
worksheet1.getColumn(2).width = 20;
worksheet1.getColumn(3).width = 20;
worksheet1.getColumn(4).width = 20;
worksheet1.getColumn(5).width = 20;
worksheet1.addRow([]);

  /**************DownloadVaccinationByDoses 30 Days**************/
  const header001 = ['vaccine_date', 'dose_1', 'dose_2','Precaution Dose','total'];
  const exportdataByDose30Days = [];
  if (this.Downloadlast30DaysVaccination) {
    this.Downloadlast30DaysVaccination.forEach(element => {
      exportdataByDose30Days.push([element.vaccine_date,element.dose_1,element.dose_2,element.dose_pd,element.total])

    });
  }
  const worksheet2 = workbook.addWorksheet('Last30DaysVaccination');
  const headerRow2 = worksheet2.addRow(header001);
  headerRow2.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' },
      bgColor: { argb: 'D3D3D3' }
    };

    cell.font = {
      name: 'Calibri',
      bold: true,
      color: { argb: '000000' }
    };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });
  headerRow2.alignment = { vertical: 'middle', horizontal: 'center' };
  exportdataByDose30Days.forEach(d => {
  const row = worksheet2.addRow(d);
});
worksheet2.getColumn(1).width = 20;
worksheet2.getColumn(2).width = 20;
worksheet2.getColumn(3).width = 20;
worksheet2.getColumn(4).width = 20;
worksheet2.getColumn(5).width = 20;
worksheet2.addRow([]);

  /**************DownloadVaccinationByDoses ALL**************/
  const header002 = ['label', 'dose1', 'dose2','Precaution Dose','total'];

  const exportdataByDoseAll = [];
  if (this.DownloadweeklyReport) {
    this.DownloadweeklyReport.forEach(element => {
      exportdataByDoseAll.push([element.label,element.dose1,element.dose2,element.dose_pd,element.total])

    });
  }
  const worksheet3 = workbook.addWorksheet('WeeklyVaccination');
  const headerRow3 = worksheet3.addRow(header002);
  headerRow3.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' },
      bgColor: { argb: 'D3D3D3' }
    };

    cell.font = {
      name: 'Calibri',
      bold: true,
      color: { argb: '000000' }
    };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });
  headerRow3.alignment = { vertical: 'middle', horizontal: 'center' };
  exportdataByDoseAll.forEach(d => {
  const row = worksheet3.addRow(d);
});
worksheet3.getColumn(1).width = 20;
worksheet3.getColumn(2).width = 20;
worksheet3.getColumn(3).width = 20;
worksheet3.getColumn(4).width = 20;
worksheet3.getColumn(5).width = 20;
worksheet3.addRow([]);

/**************exportdataByAgeToday**************/
const header1 = ['label','vac_12_14','vac_15_17', 'vac_18_45', 'vac_45_60','vac_60_above', 'total'];

const exportdataByAgeToday = [];
if (this.DownlloadVaccinationDoneByTimeAgeWise) {
  this.DownlloadVaccinationDoneByTimeAgeWise.forEach(element => {
    exportdataByAgeToday.push([element.label,element.vac_12_14,element.vac_15_17,element.vac_18_45,element.vac_45_60,element.vac_60_above,element.total])

  });
}
//const worksheet4 = workbook.addWorksheet('Today Vaccination-Agewise');
const worksheet4 = workbook.addWorksheet('VaccinationByTimeAgeWiseToday');

const header1Row = worksheet4.addRow(header1);
header1Row.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
header1Row.alignment = { vertical: 'middle', horizontal: 'center' };


exportdataByAgeToday.forEach(d => {
const row = worksheet4.addRow(d);
});
worksheet4.getColumn(1).width = 20;
worksheet4.getColumn(2).width = 20;
worksheet4.getColumn(3).width = 20;
worksheet4.getColumn(4).width = 20;
worksheet4.getColumn(5).width = 20;
worksheet4.getColumn(6).width = 20;
worksheet4.getColumn(7).width = 20;
worksheet4.addRow([]);

/**************exportdataByAge30Days**************/
const header1001 = ['vaccine_date','vac_12_14','vac_15_17', 'vac_18_45', 'vac_45_60','vac_60_above', 'total'];

const exportdataByAge30Days = [];
if (this.Downloadlast30DaysAgeWiseVaccination) {
  this.Downloadlast30DaysAgeWiseVaccination.forEach(element => {
    exportdataByAge30Days.push([element.vaccine_date,element.vac_12_14,element.vac_15_17,element.vac_18_45,element.vac_45_60,element.vac_60_above,element.total])

  });
}
const worksheet5 = workbook.addWorksheet('Last30DaysAgeWiseVaccination');
const header1Row2 = worksheet5.addRow(header1001);
header1Row2.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
header1Row2.alignment = { vertical: 'middle', horizontal: 'center' };
exportdataByAge30Days.forEach(d => {
const row = worksheet5.addRow(d);
});
worksheet5.getColumn(1).width = 20;
worksheet5.getColumn(2).width = 20;
worksheet5.getColumn(3).width = 20;
worksheet5.getColumn(4).width = 20;
worksheet5.getColumn(5).width = 20;
worksheet5.getColumn(4).width = 20;
worksheet5.getColumn(4).width = 20;
worksheet5.addRow([]);

/**************exportdataByAgeAll**************/
const header1002 = ['label','vac_12_14','vac_15_17', 'vac_18_45', 'vac_45_60','vac_60_above', 'total'];

const exportdataByAgeAll = [];
if (this.DownloadweeklyVacAgeWiseReport) {
  this.DownloadweeklyVacAgeWiseReport.forEach(element => {
    exportdataByAgeAll.push([element.label,element.vac_12_14,element.vac_15_17,element.vac_18_45,element.vac_45_60,element.vac_60_above,element.total])

  });
}
const worksheet6 = workbook.addWorksheet('weeklyAgeWiseVaccination');
const header1Row3 = worksheet6.addRow(header1002);
header1Row3.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
header1Row3.alignment = { vertical: 'middle', horizontal: 'center' };
exportdataByAgeAll.forEach(d => {
const row = worksheet6.addRow(d);
});
worksheet6.getColumn(1).width = 20;
worksheet6.getColumn(2).width = 20;
worksheet6.getColumn(3).width = 20;
worksheet6.getColumn(4).width = 20;
worksheet6.getColumn(5).width = 20;
worksheet1.getColumn(6).width = 20;
worksheet1.getColumn(7).width = 20;
worksheet6.addRow([]);

/**************exportdataRegistrationTrendsToday**************/
const header02 = ['label','age12','age15', 'age18', 'age45','age60', 'total'];
  const exportdataRegistrationTrendsToday = [];
  if (this.DownlloadImeWiseTodayRegReport) {
    this.DownlloadImeWiseTodayRegReport.forEach(element => {
      exportdataRegistrationTrendsToday.push([element.label,element.age12,element.age15,element.age18,element.age45,element.age60,element.total])

    });
  }
  const worksheet07 = workbook.addWorksheet('registrationDoneByTimeToday');
  const header02Row = worksheet07.addRow(header02);
  header02Row.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' },
      bgColor: { argb: 'D3D3D3' }
    };

    cell.font = {
      name: 'Calibri',
      bold: true,
      color: { argb: '000000' }
    };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });
  header02Row.alignment = { vertical: 'middle', horizontal: 'center' };
  exportdataRegistrationTrendsToday.forEach(d => {
  const row = worksheet07.addRow(d);
});
worksheet07.getColumn(1).width = 20;
worksheet07.getColumn(2).width = 20;
worksheet07.getColumn(3).width = 20;
worksheet07.getColumn(4).width = 20;
worksheet07.getColumn(5).width = 20;
worksheet07.getColumn(6).width = 20;
worksheet07.getColumn(7).width = 20;
worksheet07.addRow([]);

/**************exportdataRegistrationTrends30Days**************/
const header02001 = ['reg_date','age12','age15', 'age18', 'age45','age60', 'total'];

const exportdataRegistrationTrends30Days = [];

if (this.DownloadRegReportData) {
  this.DownloadRegReportData.forEach(element => {
    const reg_date = moment(element.reg_date, "YYYY-MM-DD").format('DD MMM');
    exportdataRegistrationTrends30Days.push([reg_date,element.age12,element.age15,element.age18,element.age45,element.age60,element.total])

  });
}
const worksheet8 = workbook.addWorksheet('last30DaysRegistration');
const header2Row2 = worksheet8.addRow(header02001);
header2Row2.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
header2Row2.alignment = { vertical: 'middle', horizontal: 'center' };
exportdataRegistrationTrends30Days.forEach(d => {
const row = worksheet8.addRow(d);
});
worksheet8.getColumn(1).width = 20;
worksheet8.getColumn(2).width = 20;
worksheet8.getColumn(3).width = 20;
worksheet8.getColumn(4).width = 20;
worksheet8.getColumn(5).width = 20;
worksheet8.getColumn(6).width = 20;
worksheet8.getColumn(7).width = 20;
worksheet8.addRow([]);

/**************exportdataRegistrationTrendsAll**************/
const header02002 = ['label', 'age12','age15','age18', 'age45','age60', 'total'];

const exportdataRegistrationTrendsAll = [];
if (this.DownloadRegWeekReportData) {
  this.DownloadRegWeekReportData.forEach(element => {
    exportdataRegistrationTrendsAll.push([element.label,element.age12,element.age15,element.age18,element.age45,element.age60,element.total])

  });
}
const worksheet9 = workbook.addWorksheet('weeklyRegistration');
const header2Row3 = worksheet9.addRow(header02002);
header2Row3.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
header2Row3.alignment = { vertical: 'middle', horizontal: 'center' };
exportdataRegistrationTrendsAll.forEach(d => {
const row = worksheet9.addRow(d);
});
worksheet9.getColumn(1).width = 20;
worksheet9.getColumn(2).width = 20;
worksheet9.getColumn(3).width = 20;
worksheet9.getColumn(4).width = 20;
worksheet9.getColumn(5).width = 20;
worksheet9.getColumn(6).width = 20;
worksheet9.getColumn(7).width = 20;
worksheet9.addRow([]);

/**************vaccinationAEFIChartData**************/
const header3 = ['vaccine_date', 'aefi'];
const AEFIChartExportData = [];
if (this.DownlloadLast30DaysAefi) {
  this.DownlloadLast30DaysAefi.forEach(element => {
    AEFIChartExportData.push([element.vaccine_date,element.aefi])

  });
}
const worksheet10 = workbook.addWorksheet('last30DaysAefiReported');
const header3Row = worksheet10.addRow(header3);
header3Row.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});

AEFIChartExportData.forEach(d => {
const row = worksheet10.addRow(d);
});
worksheet10.getColumn(1).width = 20;
worksheet10.getColumn(2).width = 20;
worksheet10.addRow([]);
header3Row.alignment = { vertical: 'middle', horizontal: 'center' };

/**************vaccinationByAge**************/

const header4 = ['vac_12_14','vac_15_17','vac_18_45','vac_45_60', 'above_60'];
const vaccinationByAgeexportdata = [];
this.vaccinationByAgefinalResult.push(this.DownlloadVaccinationByAge);

if (this.vaccinationByAgefinalResult) {
  this.vaccinationByAgefinalResult.forEach(element => {
    vaccinationByAgeexportdata.push([element.vac_12_14,element.vac_15_17,element.vac_18_45,element.vac_45_60,element.above_60])

  });
}
const workbook11 = workbook.addWorksheet('vaccinationByAge');
const header4Row = workbook11.addRow(header4);
header4Row.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
vaccinationByAgeexportdata.forEach(d => {
const row = workbook11.addRow(d);
});
workbook11.getColumn(1).width = 20;
workbook11.getColumn(2).width = 20;
workbook11.getColumn(3).width = 20;
workbook11.getColumn(4).width = 20;
workbook11.getColumn(5).width = 20;
workbook11.addRow([]);
header4Row.alignment = { vertical: 'middle', horizontal: 'center' };

/**************stateWiseVaccination**************/
const header5 = ['title', 'today','partial_vaccinated', 'totally_vaccinated','Precaution Dose','total'];
const stateWiseVaccinationData = [];
if (this.getBeneficiariesGroupBy) {
  this.getBeneficiariesGroupBy.forEach(element => {
    stateWiseVaccinationData.push([element.title,element.today,element.partial_vaccinated,element.totally_vaccinated,element.precaution_dose,element.total])

  });
}
const worksheet12 = workbook.addWorksheet(this.downloadExcelHeader);
const header5Row = worksheet12.addRow(header5);
header5Row.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
stateWiseVaccinationData.forEach(d => {
const row = worksheet12.addRow(d);
});
worksheet12.getColumn(1).width = 20;
worksheet12.getColumn(2).width = 20;
worksheet12.getColumn(3).width = 20;
worksheet12.getColumn(4).width = 20;
worksheet12.getColumn(5).width = 20;
worksheet12.getColumn(6).width = 20;
worksheet12.addRow([]);
header5Row.alignment = { vertical: 'middle', horizontal: 'center' };

/**************vaccinationByCategoryRuralUrbanData**************/

const header7 = ['vaccine_date', 'rural','urban'];
const RuralUrbanExportdata = [];
if (this.vaccinationByCategoryData) {
  this.vaccinationByCategoryData.forEach(element => {
    RuralUrbanExportdata.push([element.vaccine_date,element.rural,element.urban])

  });
}
const worksheet14 = workbook.addWorksheet('VaccinationByCategory');
const header7Row = worksheet14.addRow(header7);
header7Row.eachCell((cell, number) => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D3D3D3' },
    bgColor: { argb: 'D3D3D3' }
  };

  cell.font = {
    name: 'Calibri',
    bold: true,
    color: { argb: '000000' }
  };
  cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
});
RuralUrbanExportdata.forEach(d => {
const row = worksheet14.addRow(d);
});
worksheet14.getColumn(1).width = 25;
worksheet14.getColumn(2).width = 20;
worksheet14.getColumn(3).width = 20;
worksheet14.addRow([]);
header7Row.alignment = { vertical: 'middle', horizontal: 'center' };

this.tableheader
let filename = `dashboard_export.xlsx`;
  workbook.xlsx.writeBuffer().then((data: any) => {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blob, filename);

  });

  }

  getRegChartDataMonth(value = "") {
    this.publicReportService.getVacPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.registartionChartDataMonth = res.regReportData;
        console.log(this.registartionChartDataMonth);
        if (this.registartionChartDataMonth.length) {
          this.prepareDataForRegChartMonth();
        }

        if (value == "Last 30 Days") {
          this.isdayReg = false;
          this.ismonthReg = true;
          this.isweekReg = false;

        }

      }
    });
  }

  async prepareDataForRegChartMonth() {

    await this.delay(300);
    if (this.registartionChartMonth) {
      this.registartionChartMonth.destroy();
    }
    const ctx = $('#realtimeregchartmonth');
    const labels = this.registartionChartDataMonth.map(obj => moment(obj.reg_date, "YYYY-MM-DD").format('DD MMM'));
    const data1 = _.map(this.registartionChartDataMonth, 'total');
    const data5 = _.map(this.registartionChartDataMonth, 'age15');
    const data2 = _.map(this.registartionChartDataMonth, 'age18');
    const data3 = _.map(this.registartionChartDataMonth, 'age45');
    const data4 = _.map(this.registartionChartDataMonth, 'age60');
    const data6 = _.map(this.registartionChartDataMonth, 'age12');
    const format = this.numberFormatPipe;
    var regConfig = {
      type: 'line',
      data: {
        labels: labels,

        datasets: [
          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1', //'+1'
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255,  0.05)', //255, 152, 0
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            lineTension: 0,
            fill: true,
            data: data4,
          }

        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 15,
            // fontSize: 11,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },

          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.registartionChartMonth = new Chart(ctx, regConfig);
    this.registartionChartMonth.update();

  }

  getRegChartDataAll(value = "") {
    this.publicReportService.getVacPublicReports(this.state_id, this.district_id, this.todaysdate).subscribe(res => {
      if (res) {
        this.registartionChartDataAll = res.regWeekReportData;

        // console.log("reg report Month", this.registartionChartDataAll);

        if (this.registartionChartDataAll.length) {
          this.prepareDataForRegChartAll();
        }

        if (value == "All") {
          this.isdayReg = false;
          this.ismonthReg = false;
          this.isweekReg = true;

        }

      }
    });
  }

  async prepareDataForRegChartAll() {

    await this.delay(300);
    if (this.registartionChartAll) {
      this.registartionChartAll.destroy();
    }

    const ctx = $('#realtimeregweek');

    const labels = this.registartionChartDataAll.map(obj => obj.label);

    const data1 = _.map(this.registartionChartDataAll, 'total');
    const data5 = _.map(this.registartionChartDataAll, 'age15');
    const data2 = _.map(this.registartionChartDataAll, 'age18');
    const data3 = _.map(this.registartionChartDataAll, 'age45');
    const data4 = _.map(this.registartionChartDataAll, 'age60');
    const data6 = _.map(this.registartionChartDataAll, 'age12');
    const format = this.numberFormatPipe;
    var regConfig = {
      type: 'line',
      data: {
        labels: labels,

        datasets: [
          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1',
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255,  0.05)', // 255, 152, 0
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            lineTension: 0,
            fill: '2',
            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            lineTension: 0,
            fill: true,

            data: data4,
          }

        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 15,
            // fontSize: 11,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },

          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.registartionChartAll = new Chart(ctx, regConfig);
    this.registartionChartAll.update();

  }

  async prepareDataForRegChart() {

    await this.delay(300);
    if (this.registartionChart) {
      this.registartionChart.destroy();
    }


    const ctx = $('#realtimeregchart');
    if (this.registartionChartData) {
      this.registartionChartData = this.registartionChartData.sort((a, b) => (a.timestamps > b.timestamps) ? 1 : -1)
    }

    // const labels = this.registartionChartData.map(obj => obj.label);

    const labels = _.map(this.registartionChartData, (data) => {
      return moment(data.timestamps, "YYYY-MM-DD HH:mm:ssZ").format('HH:mm');
    });


    const data1 = _.map(this.registartionChartData, 'total');
    const data5 = _.map(this.registartionChartData, 'age15');
    const data2 = _.map(this.registartionChartData, 'age18');
    const data3 = _.map(this.registartionChartData, 'age45');
    const data4 = _.map(this.registartionChartData, 'age60');
    const data6 = _.map(this.registartionChartData, 'age12');
    const format = this.numberFormatPipe;
    var regConfig = {
      type: 'line',
      data: {
        labels: labels,

        datasets: [
          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1',
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255, 0.1)', //  245, 67, 148
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            lineTension: 0,
            fill: true,

            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            lineTension: 0,
            fill: true,

            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }

        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 15,
            // fontSize: 11,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },

          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.registartionChart = new Chart(ctx, regConfig);
    this.registartionChart.update();

  }

  //load AEFI report
  loadVaccinationAEFIChart() {
    const format = this.numberFormatPipe;

    if (this.vaccinationAEFIChart) {
      this.vaccinationAEFIChart.destroy();
    }

    // console.log("aefi", this.vaccinationAEFIChartData);
    const labels = this.vaccinationAEFIChartData.map(obj => moment(obj.vaccine_date).format('DD MMM'));
    const data = _.map(this.vaccinationAEFIChartData, 'aefi');
    var configuration = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: 'Total',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            borderColor: 'rgba(33, 204, 152, 1)',
            borderWidth: 2,
            pointBackgroundColor: 'rgba(33, 204, 152, 1)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data,

          }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          // align: "end",
          labels: {
            usePointStyle: true,
            // fontSize: 7,
            boxWidth: 6,
            // padding: 15,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',

            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,

              userCallback: function (label, index, labels) {
                // when the floored value is the same as the value we have a whole number
                if (Math.floor(label) === label) {
                  return label;
                }

              },
            }
          }]
        },
      }
    };
    // this.vaccinationAEFIChart.yAxis.tickFormat(d3.format(',f'));
    var ctx = $('#vaccination-aefi-seven-days');
    this.vaccinationAEFIChart = new Chart(ctx, configuration);
    this.vaccinationAEFIChart.update();

  }

  prepareDataForVaccinationByCategory() {
    if (this.vaccinationByCategoryChart) {
      this.vaccinationByCategoryChart.destroy();
    }


    // -------------------------------------------------
    Chart.helpers.drawRoundedTopRectangle = function(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      // top right corner
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      // bottom right   corner
      ctx.lineTo(x + width, y + height);
      // bottom left corner
      ctx.lineTo(x, y + height);
      // top left
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
    };
    Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
      draw: function() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var left, right, top, bottom, signX, signY, borderSkipped;
        var borderWidth = vm.borderWidth;

        if (!vm.horizontal) {
          // bar
          left = vm.x - vm.width / 2;
          right = vm.x + vm.width / 2;
          top = vm.y;
          bottom = vm.base;
          signX = 1;
          signY = bottom > top? 1: -1;
          borderSkipped = vm.borderSkipped || 'bottom';
        } else {
          // horizontal bar
          left = vm.base;
          right = vm.x;
          top = vm.y - vm.height / 2;
          bottom = vm.y + vm.height / 2;
          signX = right > left? 1: -1;
          signY = 1;
          borderSkipped = vm.borderSkipped || 'left';
        }

        // Canvas doesn't allow us to stroke inside the width so we can
        // adjust the sizes to fit if we're setting a stroke on the line
        if (borderWidth) {
          // borderWidth shold be less than bar width and bar height.
          var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
          borderWidth = borderWidth > barSize? barSize: borderWidth;
          var halfStroke = borderWidth / 2;
          // Adjust borderWidth when bar top position is near vm.base(zero).
          var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
          var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
          var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
          var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
          // not become a vertical line?
          if (borderLeft !== borderRight) {
            top = borderTop;
            bottom = borderBottom;
          }
          // not become a horizontal line?
          if (borderTop !== borderBottom) {
            left = borderLeft;
            right = borderRight;
          }
        }

        // calculate the bar width and roundess
        var barWidth = Math.abs(left - right);
        var roundness = this._chart.config.options.barRoundness || 0.5;
        var radius = barWidth * roundness * 0.8;

        // keep track of the original top of the bar
        var prevTop = top;

        // move the top down so there is room to draw the rounded top
        top = prevTop + radius;
        var barRadius = top - prevTop;

        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = borderWidth;

        // draw the rounded top rectangle
        Chart.helpers.drawRoundedTopRectangle(ctx, left, (top - barRadius + 1), barWidth, bottom - prevTop, barRadius);

        ctx.fill();
        if (borderWidth) {
          ctx.stroke();
        }

        // restore the original top value so tooltips and scales still work
        top = prevTop;
      },
    });
    Chart.defaults.roundedBar = Chart.helpers.clone(Chart.defaults.bar);

Chart.controllers.roundedBar = Chart.controllers.bar.extend({
  dataElementType: Chart.elements.RoundedTopRectangle
});
    // ------------------------------------------------



    // console.log("vaccinationByCategoryDatatest", this.vaccinationByCategoryData)
    const ctx = $('#vacc-bycategory');

    if (this.vaccinationByCategoryData) {
      this.vaccinationByCategoryData = this.vaccinationByCategoryData.sort((a, b) => (a.vaccine_date > b.vaccine_date) ? 1 : -1)
    }


    const labels = this.vaccinationByCategoryData.map(obj => moment(obj.vaccine_date, "YYYY-MM-DD").format('DD MMM'));

    const data1 = _.map(this.vaccinationByCategoryData, 'rural');
    const data2 = _.map(this.vaccinationByCategoryData, 'urban');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'bar',
            label:this.translate.instant('DASHBOARD.Urban'),
            backgroundColor: "rgba(84, 57, 252, 1)",
            borderColor: "rgba(84, 57, 252, 1)",
            data: data2,
          },
          {
            type: 'roundedBar',
            label: this.translate.instant('DASHBOARD.Rural'),
            backgroundColor: "rgba(255, 119, 35, 1)",
            borderColor: "rgba(255, 119, 35, 1)",
            data: data1,
          }
]
      },
      options: {
        cornerRadius: 20,
        legend: {
          display: true,
          position: 'bottom',
          // align: "end",
          labels: {
            usePointStyle: true,
            // fontSize: 7,
            boxWidth: 6,
            // padding: 15,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            barThickness: 10,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };
    this.vaccinationByCategoryChart = new Chart(ctx, vaccConfig);
    this.vaccinationByCategoryChart.update();
  }

  prepareDataForDoughnutChartForTable() {
    const format = this.numberFormatPipe;
    var count = 0;
    // for(let i=0; i<=this.getVaccinationByStateUTData.length;i++){
    // this.getVaccinationByStateUTData = this.getVaccinationByStateUTData.slice(0, 200);
    // console.log(" this.getVaccinationByStateUTData", this.getVaccinationByStateUTData)
    this.getVaccinationByStateUTData.forEach((res) => {
      count = count + 1;


      this.charts.push(

        new Chart('vaccination-table-data' + count, {
          type: 'doughnut',
          data: {
            labels: ['Dose 1', 'Dose 2'],
            datasets: [
              {
                data: [res.partial_vaccinated, res.totally_vaccinated],
                //borderColor: "#3cba9f",
                backgroundColor: [
                  ('#21CC98'),
                  ('#FF9800')

                ]
              }
            ]
          },
          options: {
            cutoutPercentage: 70,
            borderRadius: 30,
            // rotation: 1 * Math.PI,
            // circumference: 1 * Math.PI,
            responsive: true,
            animation: {
              animateScale: true,
              animateRotate: true
            },
            tooltips: {
              enabled: false
            },
            legend: {
              display: false,
            }
          }
        })
      );

    });
    // }
  }

  async prepareDataForVaccAgewiseToday() {
    await this.delay(300);

    if (this.vaccinationAgeChartToday) {
      this.vaccinationAgeChartToday.destroy();
    }
    if (this.vaccinationAgeDataToday) {
      this.vaccinationAgeDataToday = this.vaccinationAgeDataToday.sort((a, b) => (a.timestamps > b.timestamps) ? 1 : -1)
    }
    const ctx = $('#vacc-agewise-today');


    const labels = _.map(this.vaccinationAgeDataToday, (data) => {
      return moment(data.timestamps, "YYYY-MM-DDTHH:mm:ssZ").subtract(330, "minutes").format('HH:mm');
    });


    const data1 = _.map(this.vaccinationAgeDataToday, 'total');
    const data5 = _.map(this.vaccinationAgeDataToday, 'vac_15_17');
    const data2 = _.map(this.vaccinationAgeDataToday, 'vac_18_45');
    const data3 = _.map(this.vaccinationAgeDataToday, 'vac_45_60');
    const data4 = _.map(this.vaccinationAgeDataToday, 'vac_60_above');
    const data6= _.map(this.vaccinationAgeDataToday, 'vac_12_14');
    const format = this.numberFormatPipe;


    var vaccConfig = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [

          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1',
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255,  0.05)', // 255, 152, 0
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }



        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },

        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.vaccinationAgeChartToday = new Chart(ctx, vaccConfig);
    this.vaccinationAgeChartToday.update();
  }

  async prepareDataForVaccAgewiseLast30Days() {
    await this.delay(300);
    if (this.vaccinationAgeChartMonth) {
      this.vaccinationAgeChartMonth.destroy();
    }

    const ctx = $('#vacc-agewise-month');

    const labels = this.vaccinationAgeDataMonth.map(obj => moment(obj.vaccine_date, "YYYY-MM-DD").format('DD MMM'));


    const data1 = _.map(this.vaccinationAgeDataMonth, 'total');
    const data5 = _.map(this.vaccinationAgeDataMonth, 'vac_15_17');
    const data2 = _.map(this.vaccinationAgeDataMonth, 'vac_18_45');
    const data3 = _.map(this.vaccinationAgeDataMonth, 'vac_45_60');
    const data4 = _.map(this.vaccinationAgeDataMonth, 'vac_60_above');
    const data6 = _.map(this.vaccinationAgeDataMonth, 'vac_12_14');
    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1',
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255,  0.05)', // 255, 152, 0
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }

        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.vaccinationAgeChartMonth = new Chart(ctx, vaccConfig);
    this.vaccinationAgeChartMonth.update();
  }

  async prepareDataForVaccAgewiseAll() {
    await this.delay(300);
    if (this.vaccinationAgeChartAll) {
      this.vaccinationAgeChartAll.destroy();
    }


    const ctx = $('#vacc-agewise-all');

    const labels = this.vaccinationAgeDataAll.map(obj => obj.label);


    const data1 = _.map(this.vaccinationAgeDataAll, 'total');
    const data5 = _.map(this.vaccinationAgeDataAll, 'vac_15_17');
    const data2 = _.map(this.vaccinationAgeDataAll, 'vac_18_45');
    const data3 = _.map(this.vaccinationAgeDataAll, 'vac_45_60');
    const data4 = _.map(this.vaccinationAgeDataAll, 'vac_60_above');
    const data6 = _.map(this.vaccinationAgeDataAll, 'vac_12_14');
    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: this.translate.instant('DASHBOARD.Total'),
            backgroundColor: 'rgb(33, 204, 152, 0.1)',
            borderColor: 'rgb(33, 204, 152)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(33, 204, 152)',
            pointBorderWidth: 1,
            strokeColor: "rgba(54, 162, 235, 0.2)",
            pointRadius: 3,
            fill: '+1',
            lineTension: 0,
            data: data1,
          },
          {
            type: 'line',
            label: '12-14',
            backgroundColor: 'rgb(178, 76, 194, 0.1)',
            borderColor: 'rgb(178, 76, 194)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(178, 76, 194)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data6,
          },
          {
            type: 'line',
            label: '15-17',
            backgroundColor: 'rgb(0, 179, 255,  0.05)', // 255, 152, 0
            borderColor: 'rgb(0, 179, 255)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(0, 179, 255)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data5,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.18-44'),
            backgroundColor: 'rgb(255, 152 , 0, 0.1)',
            borderColor: 'rgb(255, 152 , 0)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(255, 152 , 0)',
            pointBorderWidth: 1,

            pointRadius: 3,
            fill: '+2',
            lineTension: 0,
            data: data2,
            shadowColor : '#F54394'
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.45-60'),
            backgroundColor: 'rgb(84, 57, 252,0.1)',
            borderColor: 'rgb(84, 57, 252)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(84, 57, 252)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data3,
          },
          {
            type: 'line',
            label: this.translate.instant('DASHBOARD.Above_60'),
            backgroundColor: 'rgb(245, 67, 148, 0.2)',
            borderColor: 'rgb(245, 67, 148)',
            borderWidth: 2,
            pointBackgroundColor: "rgb(245, 67, 148)",
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            lineTension: 0,
            data: data4,
          }

        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        }
      }
    };

    this.vaccinationAgeChartAll = new Chart(ctx, vaccConfig);
    this.vaccinationAgeChartAll.update();
  }
  getLiveVaccinationCounter() {
    const channelName = `covid_vaccination_live_counter`;
    this.webSocket.listen(channelName).subscribe((data:any) => {
      // let liveData = data.split('::@::');
      // this.totalVaccinationCounter = parseInt(liveData[0]);
      this.totalVaccinationCounter = parseInt(data);
    });

    const channelNameReg = `covid_registration_live_counter`;
    this.webSocket.listen(channelNameReg).subscribe((data:any) => {
      this.totalRegistrationCounter = parseInt(data);
    });

    const channelNamepartialVacc = `covid_partially_vaccination_live_counter`;
    this.webSocket.listen(channelNamepartialVacc).subscribe((data:any) => {
      this.partialVaccinationCounter = parseInt(data);
    });

    const channelNametotalVacc = `covid_fully_vaccination_live_counter`;
    this.webSocket.listen(channelNametotalVacc).subscribe((data:any) => {
      this.fullyVaccinationCounter = parseInt(data);
    });

    this.webSocket.listenAgeSocket('covid_vaccination_bifurcation').subscribe((data: any) => {
      this.total12_14Vaccination = data['vaccination_12_14_total'];
      this.total15_17Vaccination = data['vaccination_15_17_total'];
     this.total18_44Vaccination = data['vaccination_18_44_total'];
      this.total45_60Vaccination = data['vaccination_45_60_total'];
      this.totalabove_60Vaccination = data['vaccination_above_60_total'];
      this.total_hcw_flw_precaution_vaccinations = data['vaccination_18_44_precaution_dose'] + data['vaccination_45_60_precaution_dose'];
      this.total_60_plus_precaution_vaccinations = data['vaccination_above_60_precaution_dose']
    })
  }
  getDataForLiveVaccCountChart() {
    this.publicReportService.getLiveVaccinationCounterChart(this.todaysdate).subscribe(res => {
      if (res) {
        this.liveVaccData = res;
        for (let i = 0; i < this.liveVaccData.length; i++) {
          this.liveVaccData[i].last5mins = i == 0 ? 0 : this.liveVaccData[i].count - this.liveVaccData[i - 1].count
        }

        this.liveVaccData = this.liveVaccData.slice(Math.max(this.liveVaccData.length - 12, -1))
        console.log(" this.liveVaccData1", this.liveVaccData);
        this.prepareDataForLiveVaccCount();
      }
    });
  }

  prepareDataForLiveVaccCount() {
    if (this.liveVaccChart) {
      this.liveVaccChart.destroy();
    }

    const ctx = $('#liveVacc');

    // if (this.liveVaccData) {
    //   this.liveVaccData = this.liveVaccData.sort((a, b) => (a.timestamps > b.timestamps) ? 1 : -1)
    // }
    // -----------------------------------------
    // Chart.defaults.LineWithLine = Chart.defaults.line;
    // Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    //    draw: function(ease) {
    //       Chart.controllers.line.prototype.draw.call(this, ease);

    //       if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
    //          var activePoint = this.chart.tooltip._active[0],
    //              ctx = this.chart.ctx,
    //              x = activePoint.tooltipPosition().x,
    //              topY = this.chart.legend.bottom,
    //              bottomY = this.chart.chartArea.bottom;

    //          // draw line
    //          ctx.save();
    //          ctx.beginPath();
    //          ctx.moveTo(x, topY);
    //          ctx.lineTo(x, bottomY);
    //          ctx.lineWidth = 1;
    //          ctx.strokeStyle = '#808080';
    //          ctx.stroke();
    //          ctx.restore();
    //       }
    //    }
    // });



    // ----------------------------------------



    const labels = _.map(this.liveVaccData, (data) => {
      return moment(data.time, "YYYY-MM-DDTHH:mm:ssZ").add(330, "minutes").format('hh:mm A');
    });

    const data1 = _.map(this.liveVaccData, 'last5mins');
    // console.log(" this.liveVaccDataxcXC",  this.liveVaccData);
    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      // borderRadius: 50,
      // borderwidth:10,
      data: {
        labels: labels,

        datasets: [
          {
            //   type: 'line',
            //   // label: '5 Min Interval',
            //   backgroundColor: "rgb(28,169,121, 1)",
            //   borderColor: "rgb(28,169,121, 1)",

            //   data: data1,
            //   borderwidth:10,
            //  borderRadius: 50,
            // //  corners: 'round',
            //   // bezierCurve : false



            type: 'line',
            // tension: 0.1,
            backgroundColor: 'rgb(28,169,121, .1)',
            borderColor: 'rgb(28,169,121, 1)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(28,169,121, 1)',
            pointBorderWidth: 1.5,
            pointRadius: 1.5,
            fill: true,
            bezierCurve: false,
            data: data1,
          }

        ]
      },
      options: {
        borderRadius: 50,
        // cornerRadius: 20,
        // barRoundness: 1,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          yAlign: 'top',
          displayColors: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.datasets[tooltipItem.datasetIndex].label || '';


              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,


          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            display: true,
            // barPercentage:1.0,
            // categoryPercentage:1.0,
            // // maintainAspectRatio :false,
            beginAtZero: true,
            // barThickness: 7,
            // borderRadius: 50,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 3,
              fontSize: 6,
              display: true,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000",
              //  callback: function (label, index, labels) {
              //     // return label / 100000 + 'L';
              //     return ""
              //  }
            },
            stacked: false,
            gridLines: {
              display: true,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000',
              // color: "#808080"
            },
          }],
          yAxes: [{

            stacked: false,
            barPercentage: 0.35,
            dispaly: false,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [2, 4],
              zeroLineColor: 'rgb(247, 250, 252)',
              display: false,
              offsetGridLines: true
            },
            ticks: {
              dispaly: true,
              fontSize: 6,
              beginAtZero: false,
              autoSkip: true,
              maxTicksLimit: 3,
              fontColor: "#000000",
              callback: function (label, index, labels) {
                return label / 100000 + 'L';
                // return ""
              }
            }
          }]
        },
        // annotation: {
        //   annotations: [{
        //     type: 'line',
        //     mode: 'vertical',
        //     scaleID: 'y-axis-0',
        //     value: 5,
        //     borderColor: 'rgb(75, 192, 192)',
        //     borderWidth: 4,
        //     label: {
        //       enabled: false,
        //       content: 'Test label'
        //     }
        //   }]
        // }


      },
      // plugins: [{
      //   beforeInit: function (chart) {
      //     chart.data.labels.forEach(function (e, i, a) {
      //       if (/\n/.test(e)) {
      //         a[i] = e.split(/\n/)
      //       }
      //     })
      //   }
      // }]
    };

    this.liveVaccChart = new Chart(ctx, vaccConfig);
    this.liveVaccChart.update();
  }
  prepareDataForLiveVaccStareaming() {
    if (this.liveVaccChartStreaming) {
      this.liveVaccChartStreaming.destroy();
    }

    const ctx = $('#liveVaccStreaming');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(20, 122, 214, 0.5)',
          borderColor: 'rgb(20, 122, 214)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display: false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display: false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly: false,
            // beginAtZero: true,
            gridLines: {
              display: false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly: false,
              userCallback: function (value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreaming = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreaming.update();
    this.updateData();
  }
  async updateData() {
    const channelName = `covid_vaccination_live_counter`;
    this.webSocket.listen(channelName).subscribe((data: any) => {
      let currentData = parseInt(data);
      let label = moment(new Date()).format('HH:mm:ss')
      this.liveVaccChartStreaming.data.labels.push(label);
      this.liveVaccChartStreaming.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsData) {
            diff = currentData - this.prevsData
          }
          this.prevsData = currentData;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsData) {
            diff = currentData - this.prevsData
          }
          this.prevsData = currentData;
          dataset.data.push(diff)
        }
      });
      if (this.updateCountTotalVacc > this.numberOfElements) {
        this.liveVaccChartStreaming.data.labels.shift();
        this.liveVaccChartStreaming.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVacc++;
      }
      this.liveVaccChartStreaming.update();
      this.liveVaccChartStreaming = this.liveVaccChartStreaming;
    })
  }
  prepareDataForLiveVaccStareamingRegistration() {
    if (this.liveVaccChartStreamingRegistration) {
      this.liveVaccChartStreamingRegistration.destroy();
    }

    const ctx = $('#liveVaccStreamingReg');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(1, 113, 113, 0.5)',
          borderColor: 'rgb(1, 113, 113, 1)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
             tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display: false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display: false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly: false,
            // beginAtZero: true,
            gridLines: {
              display: false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly: false,
              userCallback: function (value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreamingRegistration = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreamingRegistration.update();
    this.updateDataRegistration();
  }
  async updateDataRegistration() {
    const channelName = `covid_registration_live_counter`;
    this.webSocket.listen(channelName).subscribe((data: any) => {
      let currentData = parseInt(data);
      let label = moment(new Date()).format('HH:mm:ss')
      this.liveVaccChartStreamingRegistration.data.labels.push(label);
      this.liveVaccChartStreamingRegistration.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsRegData) {
            diff = currentData - this.prevsRegData
          }
          this.prevsRegData = currentData;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsRegData) {
            diff = currentData - this.prevsRegData
          }
          this.prevsRegData = currentData;
          dataset.data.push(diff)
        }
      });
      if (this.updateCountTotalReg > this.numberOfElements) {
        this.liveVaccChartStreamingRegistration.data.labels.shift();
        this.liveVaccChartStreamingRegistration.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalReg++;
      }
      this.liveVaccChartStreamingRegistration.update();
      this.liveVaccChartStreamingRegistration = this.liveVaccChartStreamingRegistration;
    })
  }
  prepareDataForLiveVaccStareamingPartialVacc() {
    if (this.liveVaccChartStreamingPartialVacc) {
      this.liveVaccChartStreamingPartialVacc.destroy();
    }

    const ctx = $('#liveVaccStreamingPartialVacc');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(255, 154, 49, 0.5)',
          borderColor: 'rgb(255, 154, 49)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display: false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display: false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly: false,
            // beginAtZero: true,
            gridLines: {
              display: false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly: false,
              userCallback: function (value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreamingPartialVacc = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreamingPartialVacc.update();
    this.updateDataPartialVacc();
  }
  async updateDataPartialVacc() {
    const channelName = `covid_partially_vaccination_live_counter`;
    this.webSocket.listen(channelName).subscribe((data: any) => {
      let currentData = parseInt(data);
      let label = moment(new Date()).format('HH:mm:ss')
      this.liveVaccChartStreamingPartialVacc.data.labels.push(label);
      this.liveVaccChartStreamingPartialVacc.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsPartialVaccData) {
            diff = currentData - this.prevsPartialVaccData
          }
          this.prevsPartialVaccData = currentData;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsPartialVaccData) {
            diff = currentData - this.prevsPartialVaccData
          }
          this.prevsPartialVaccData = currentData;
          dataset.data.push(diff)
        }
      });
      if (this.updateCountPartialVacc > this.numberOfElements) {
        this.liveVaccChartStreamingPartialVacc.data.labels.shift();
        this.liveVaccChartStreamingPartialVacc.data.datasets[0].data.shift();
      } else {
        this.updateCountPartialVacc++;
      }
      this.liveVaccChartStreamingPartialVacc.update();
      this.liveVaccChartStreamingPartialVacc = this.liveVaccChartStreamingPartialVacc;
    })
  }
  prepareDataForLiveVaccStareamingFullyVacc() {
    if (this.liveVaccChartStreamingFullyVacc) {
      this.liveVaccChartStreamingFullyVacc.destroy();
    }

    const ctx = $('#liveVaccStreamingFullyVacc');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(47, 181, 141, 0.5)',
          borderColor: 'rgb(47, 181, 141)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          showScale: false,
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display: false,
            // beginAtZero: true,
            // ticks: {
            //   autoSkip: true,
            //   maxTicksLimit: 5,
            //   fontSize: 6,
            //   display:false,
            //   maxRotation: 0,
            //   minRotation: 0,
            //   fontColor: "#000000"
            // },
            // stacked: false,
            // gridLines: {
            //   display: false,
            //   drawBorder: true,
            //   borderDash: [2, 4],
            //   zeroLineWidth: 0.05,
            //   zeroLineColor: '#000000'
            // },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly: false,
            // beginAtZero: true,
            gridLines: {
              display: false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly: false,
              userCallback: function (value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreamingFullyVacc = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreamingFullyVacc.update();
    this.updateDataFullyVacc();
  }
  async updateDataFullyVacc() {
    const channelName = `covid_fully_vaccination_live_counter`;
    this.webSocket.listen(channelName).subscribe((data: any) => {
      let currentData = parseInt(data);
      let label = moment(new Date()).format('HH:mm:ss')
      this.liveVaccChartStreamingFullyVacc.data.labels.push(label);
      this.liveVaccChartStreamingFullyVacc.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsFullyVaccData) {
            diff = currentData - this.prevsFullyVaccData
          }
          this.prevsFullyVaccData = currentData;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsFullyVaccData) {
            diff = currentData - this.prevsFullyVaccData
          }
          this.prevsFullyVaccData = currentData;
          dataset.data.push(diff)
        }
      });
      if (this.updateCountFullyVacc > this.numberOfElements) {
        this.liveVaccChartStreamingFullyVacc.data.labels.shift();
        this.liveVaccChartStreamingFullyVacc.data.datasets[0].data.shift();
      } else {
        this.updateCountFullyVacc++;
      }
      this.liveVaccChartStreamingFullyVacc.update();
      this.liveVaccChartStreamingFullyVacc = this.liveVaccChartStreamingFullyVacc;
    })
  }

  loadVaccinationByAgeChart() {
    const format = this.numberFormatPipe;
    if (this.vaccinationByAgeChart) {
      this.vaccinationByAgeChart.destroy();
}
    console.log("this.vaccinationByAgeChartData", this.vaccinationByAgeChartData)
    const labels_data = Object.keys(this.vaccinationByAgeChartData);
    const labels = labels_data.map(obj => obj.replace('vac_', '').replace('_', '-'));
    labels.shift();

    const vac_15_17 = this.vaccinationByAgeChartData.vac_15_17
    const vac_18_45 = this.vaccinationByAgeChartData.vac_18_45
    const vac_45_60 = this.vaccinationByAgeChartData.vac_45_60
    const above_60 = this.vaccinationByAgeChartData.above_60


    console.log("check", vac_18_45);
    var configuration = {
      type: 'bar',

      data: {
        datasets: [
          {
            label: '15-17',
            data: [vac_15_17],
            backgroundColor: [
              // "rgb(254, 125, 90)",
              // "rgb(243, 244, 249)"
              'rgb(15, 22, 53)'
            ],
          },
          {
            label: '18-44',
            data: [vac_18_45],
            backgroundColor: 'rgb(50 72 158)'
          },
          {
            label: '45-60',
            data: [vac_45_60],
            backgroundColor: 'rgb(2, 99, 255)'
          },
          {
            label: 'Above 60',
            data: [above_60],
            backgroundColor: 'rgb(100, 154, 241)'
          }
        ]


      },
      options: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            barThickness: 40,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              display: false

            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-by-age');
    this.vaccinationByAgeChart = new Chart(ctx, configuration);
    this.vaccinationByAgeChart.update();
  }

  prepareDataForDoughnutChartGender() {

    const format = this.numberFormatPipe;
    if (this.genderVaccPieChart) {
      this.genderVaccPieChart.destroy()
    }



    const male = this.topBlockReport?.vaccination?.male
    const female = this.topBlockReport?.vaccination?.female
    const others = this.topBlockReport?.vaccination?.others
    const total = this.topBlockReport?.vaccination?.total_doses

    console.log("male", this.topBlockReport)
    var configcmr2 = {
      type: 'doughnut',

      data: {
        datasets: [
          /* Outer doughnut data starts*/
          {
            data: [this.topBlockReport?.vaccination?.male,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(84, 57, 252)",
              "rgb(243, 244, 249)"
            ],
            label: 'Male',
            borderRadius: 30
          },
          /* Outer doughnut data ends*/
          /* Inner doughnut data starts*/
          {
            data: [this.topBlockReport?.vaccination?.female,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(245, 67, 148)",
              "rgb(243, 244, 249)"
            ],
            label: 'Female',

          },
          {
            data: [this.topBlockReport?.vaccination?.others,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(255, 152, 0)",
              "rgb(243, 244, 249)"
            ],
            label: 'Others',

          }
        ],
        labels: [
          "Male",
          "Female",
          "Others"

        ],

      },
      options: {
        cutoutPercentage: 60,
        borderRadius: 30,
        // rotation: 1 * Math.PI,
        // circumference: 1 * Math.PI,
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          mode: 'label',


          callbacks: {
            label: function (item, data) {
              console.log(data.labels, item);
              return data.datasets[item.datasetIndex].label + ": " + format.transform(data.datasets[item.datasetIndex].data[item.index]);
            }
          }
        },
        legend: {
          display: false,
          position: 'right',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 50,
            // fontSize: 11,
          }
        }
      }
    };




    const genderCtx = $('#total-vaccinated-gender');
    this.genderVaccPieChart = new Chart(genderCtx, configcmr2);


  }


  prepareDataForDoughnutChartVaccType() {

    const format = this.numberFormatPipe;
    if (this.materialVaccPieChart) {
      this.materialVaccPieChart.destroy()
    }



    const male = this.topBlockReport?.vaccination?.male
    const female = this.topBlockReport?.vaccination?.female
    const others = this.topBlockReport?.vaccination?.others
    const total = this.topBlockReport?.vaccination?.total_doses

    console.log("male", this.topBlockReport)
    var configcmr2 = {
      type: 'doughnut',

      data: {
        datasets: [
          /* Outer doughnut data starts*/
          {
            data: [this.topBlockReport?.vaccination?.covishield,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(59, 125, 254)",
              "rgb(243, 244, 249)"
            ],
            label: 'Covishield',
            borderRadius: 30
          },
          /* Outer doughnut data ends*/
          /* Inner doughnut data starts*/
          {
            data: [this.topBlockReport?.vaccination?.covaxin,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(254, 125, 90)",
              "rgb(243, 244, 249)"
            ],
            label: 'Covaxin',

          },
          {
            data: [this.topBlockReport?.vaccination?.sputnik,
            this.topBlockReport?.vaccination?.total_doses],
            backgroundColor: [
              "rgb(35, 200, 150)",
              "rgb(243, 244, 249)"
            ],
            label: 'Sputnik V',

          }
        ],
        labels: [
          "Covishield",
          "Covaxin",
          "Sputnik V"

        ],

      },
      options: {
        cutoutPercentage: 60,
        borderRadius: 30,
        // rotation: 1 * Math.PI,
        // circumference: 1 * Math.PI,
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          mode: 'label',


          callbacks: {
            label: function (item, data) {
              console.log(data.labels, item);
              return data.datasets[item.datasetIndex].label + ": " + format.transform(data.datasets[item.datasetIndex].data[item.index]);
            }
          }
        },
        legend: {
          display: false,
          position: 'right',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 50,
            // fontSize: 11,
          }
        }
      }
    };




    const materialCtx = $('#material-used');
    this.materialVaccPieChart = new Chart(materialCtx, configcmr2);


  }

  prepareDataForDoughnutChartVaccTypeNew() {

    const format = this.numberFormatPipe;
    if (this.materialVaccPieChartnew) {
      this.materialVaccPieChartnew.destroy()
    }



    const male = this.topBlockReport?.vaccination?.male
    const female = this.topBlockReport?.vaccination?.covaxin
    const others = this.topBlockReport?.vaccination?.sputnik
    const total = this.topBlockReport?.vaccination?.total_doses

    const labels = ['Covishield', 'Covaxin', 'Sputnik V']
    const bgcolor = ['rgb(59, 125, 254)', 'rgb(254, 125, 90)', 'rgb(35, 200, 150)']
    const vaccData = [

      this.topBlockReport?.vaccination?.covishield,

      this.topBlockReport?.vaccination?.covaxin,

      this.topBlockReport?.vaccination?.sputnik,

    ]

    if(this.topBlockReport.vaccination.corbevax){

      labels.push('Corbevax');

      vaccData.push(this.topBlockReport?.vaccination?.corbevax)
      bgcolor.push('rgb(245, 67, 148)')

    }
    if(this.topBlockReport.vaccination.covovax){

      labels.push('Covovax');
      bgcolor.push('rgb(178, 76, 194)')
      vaccData.push(this.topBlockReport?.vaccination?.covovax)
    }

    if(this.topBlockReport.vaccination.incovacc){
      labels.push('iNCOVACC');
      bgcolor.push('rgb(92, 186, 24)')
      vaccData.push(this.topBlockReport?.vaccination?.incovacc)
      }

    if(this.topBlockReport.vaccination.gemcovacc){
      labels.push('GEMCOVAC');
      bgcolor.push('rgb(33, 24, 204)')
      vaccData.push(this.topBlockReport?.vaccination?.gemcovacc)
      }

    if(this.topBlockReport.vaccination.gemcovacc_om){
      labels.push('GEMCOVAC®-OM');
      bgcolor.push('rgb(37, 196, 172)')
      vaccData.push(this.topBlockReport?.vaccination?.gemcovacc_om)
      }

    // console.log("male",this.topBlockReport)
    var configcmr2 = {
      type: 'doughnut',



      data: {
        datasets: [{
          data: vaccData,
          // backgroundColor: ['rgb(59, 125, 254)', 'rgb(254, 125, 90)', 'rgb(35, 200, 150)','rgb(245, 67, 148)','rgb(178, 76, 194)'],
          backgroundColor:bgcolor,
          borderWidth: 1,
        }],
        labels: labels
      },
      options: {
        cutoutPercentage: 60,
        borderRadius: 30,
        // rotation: 1 * Math.PI,
        // circumference: 1 * Math.PI,
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var indice = tooltipItem.index;
              const value = data.datasets[0].data[indice] || 0
              const dataNum = Math.round(value * 100) / 100;
              return data.labels[indice] + ': ' + format.transform(data.datasets[0].data[indice]) + '';
            }
          }
        },
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            // padding: 50,
            // fontSize: 11,
          }
        }
      }
    };




    const materialCtxnew = $('#material-used-new');
    this.materialVaccPieChartnew = new Chart(materialCtxnew, configcmr2);


  }



  prepareDataForPieChartGenderNew() {
    const format = this.numberFormatPipe;
    if (this.genderVaccPieChartNew) {
      this.genderVaccPieChartNew.destroy();
    }
    // console.log("this.vaccinationByAgeChartData", this.vaccinationByAgeChartData)
    // const labels_data = Object.keys(this.vaccinationByAgeChartData);
    // const labels = labels_data.map(obj => obj.replace('vac_', '').replace('_', '-'));
    // labels.shift();
    // const data = Object.values(this.vaccinationByAgeChartData);
    // data.shift();
    var configuration = {
      type: 'pie',
      // data: {
      //   labels: labels,
      //   datasets: [{
      //     type: 'bar',
      //     label: 'Vaccinations By Age',
      //     backgroundColor: "rgb(85 86 253)",
      //     borderColor: "rgb(85 86 253)",
      //     data: data,
      //   }]
      // },

      data: {
        datasets: [{
          data: [
            // this.vaccinationByAgeChartData.total,
            this.topBlockReport?.vaccination?.male,
            this.topBlockReport?.vaccination?.female,
            this.topBlockReport?.vaccination?.others
          ],
          backgroundColor: ['rgb(84, 57, 252)', 'rgb(245, 67, 148)', 'rgb(255, 152, 0)'],
          borderWidth: 1,
        }],
        labels: ['Male', 'Female', 'Others']
      },
      options: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            // fontSize: 11,
            boxWidth: 6,
            // padding: 15,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var indice = tooltipItem.index;
              const value = data.datasets[0].data[indice] || 0
              const dataNum = Math.round(value * 100) / 100;
              return data.labels[indice] + ': ' + format.transform(data.datasets[0].data[indice]) + '';
            }
          }
        },

      }
    };

    var ctx = $('#total-vaccinated-gender-new');
    this.genderVaccPieChartNew = new Chart(ctx, configuration);
    this.genderVaccPieChartNew.update();
  }

  loadVaccinationByAgeChartnew() {
    const format = this.numberFormatPipe;
    if (this.vaccinationByAgeChartNew) {
      this.vaccinationByAgeChartNew.destroy();
    }
    console.log("this.vaccinationByAgeChartData", this.vaccinationByAgeChartData)
    const labels_data = Object.keys(this.vaccinationByAgeChartData);
    const labels = labels_data.map(obj => obj.replace('vac_', '').replace('_', '-'));
    labels.shift();

    const vac_15_17 = this.vaccinationByAgeChartData.vac_15_17
    const vac_18_45 = this.vaccinationByAgeChartData.vac_18_45
    const vac_45_60 = this.vaccinationByAgeChartData.vac_45_60
    const above_60 = this.vaccinationByAgeChartData.above_60
    const vac_12_14 = this.vaccinationByAgeChartData.vac_12_14
    // console.log("check", vac_18_45);
    var configuration = {
      type: 'bar',

      data: {
        datasets: [
          {
            label: '12-14',
            data: [vac_12_14],
            backgroundColor: [
              // "rgb(254, 125, 90)",
              // "rgb(243, 244, 249)"
              'rgb(1, 2, 13)'
            ],
          },
          {
            label: '15-17',
            data: [vac_15_17],
            backgroundColor: [
              // "rgb(254, 125, 90)",
              // "rgb(243, 244, 249)"
              // 'rgb(15, 22, 53)'
              'rgb(50, 72, 158)'
            ],
          },
          {
            label: '18-44',
            data: [vac_18_45],
            // backgroundColor: 'rgb(50 72 158)'
            backgroundColor: 'rgb( 86, 90, 143)'


          },
          {
            label: '45-60',
            data: [vac_45_60],
            backgroundColor: 'rgb(2, 99, 255)'
          },
          {
            label: 'Above 60',
            data: [above_60],
            backgroundColor: 'rgb(100, 154, 241)'
          }
        ]


      },
      options: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            boxWidth: 6,
          }
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            title: function (tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            barThickness: 40,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              display: false

            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-by-age-new');
    this.vaccinationByAgeChartNew = new Chart(ctx, configuration);
    this.vaccinationByAgeChartNew.update();
  }

  loadDataByStateTab(state_id = "", district_id = "") {
    console.log("sate", state_id);
    this.isByAge = false;
    this.isByDoses = true;
    this.isdayVaccAge = false;
    this.ismonthVaccAge = false;
    this.isweekVaccAge = false;
    this.isday = true;
    this.ismonth = false;
    this.isweek = false;
    if(this.Heatmap !=undefined){
      this.Heatmap.getStatename(state_id);
    }
    this.statename = state_id;
    this.stateId = this.states.filter(e => e.state_name == state_id);
    this.chartFlag = true;
    console.log("stateId", this.stateId)
    this.getDashboardData(this.stateId[0].state_id, district_id);
    this.getVacChartData();
    this.iconChange(this.stateId[0].state_id);
    // this.getVacChartData('Last 30 Days')
    // this.getRegChartDataMonth('Last 30 Days')
    // this.getVaccChartAgewiseDataMonth('Last 30 Days')

  }

  getDistrictID(stateId) {
    // console.log("stateId", stateId)
    this.publicReportService.getDistricts().subscribe((res) => this.districtListnew = res);
    if (stateId !== "") {
      this.districtListfromstate = this.districtListnew.filter(e => e.state_id == stateId);
      // console.log(this.districtListfromstate)
    }
  }


  loadDataByDitrictTab(district_name = "") {
    this.isByAge = false;
    this.isByDoses = true;
    this.isdayVaccAge = false;
    this.ismonthVaccAge = false;
    this.isweekVaccAge = false;
    this.isday = true;
    this.ismonth = false;
    this.isweek = false;

    this.statedistrict=this.districtListnew.filter(e => e.state_id == this.state_id);
    this.district = this.statedistrict.filter(e => e.district_name == district_name);
    // this.chartFlag = false;
if(this.state_id !=""){
  this.chartFlag = true;
    // this.getNewDashboardDataforDistrict(this.district[0].district_id);
    this.getDashboardData(this.state_id, this.district[0].district_id);
    this.getVacChartData();
}
    // this.getVacChartData('Last 30 Days')
    // this.getRegChartDataMonth('Last 30 Days')
    // this.getVaccChartAgewiseDataMonth('Last 30 Days')

  }

  filterFunction() {
    console.log("drop")
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    let div = document.getElementById("myDropdown");
    a = div.getElementsByTagName("a");
    for (i = 0; i < a.length; i++) {
      txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  }


  getVacPerc(data, dose_type) {
    if (dose_type == 1) {
      return (data.partial_vaccinated / data.total).toFixed(2);
    } else {
      return (data.totally_vaccinated / data.total).toFixed(2)
    }
  }

  liveVaccChartStreaming12_14;
  prepareDataForLiveVaccStareaming12_14() {
    if (this.liveVaccChartStreaming12_14) {
      this.liveVaccChartStreaming12_14.destroy();
    }

    const ctx = $('#liveVacc12_14');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgba(243,201,42,0.55)',
          borderColor: 'rgb(243,201,42)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display:false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display:false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly:false,
            // beginAtZero: true,
            gridLines: {
              display:false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly:false,
              userCallback: function(value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreaming12_14 = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreaming12_14.update();
  }


   liveVaccChartStreaming15_17;
  prepareDataForLiveVaccStareaming15_17() {
    if (this.liveVaccChartStreaming15_17) {
      this.liveVaccChartStreaming15_17.destroy();
    }

    const ctx = $('#liveVacc15_17');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(178, 76, 194, 0.5)',
          borderColor: 'rgb(178, 76, 194)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display:false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display:false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly:false,
            // beginAtZero: true,
            gridLines: {
              display:false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly:false,
              userCallback: function(value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreaming15_17 = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreaming15_17.update();
  }


  liveVaccChartStreaming18_44;
  prepareDataForLiveVaccStareaming18_44() {
    if (this.liveVaccChartStreaming18_44) {
      this.liveVaccChartStreaming18_44.destroy();
    }

    const ctx = $('#liveVacc18_44');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(225, 75, 75, 0.5)',
          borderColor: 'rgb(225, 75, 75)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display:false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display:false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly:false,
            // beginAtZero: true,
            gridLines: {
              display:false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly:false,
              userCallback: function(value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreaming18_44 = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreaming18_44.update();
  }

  liveVaccChartStreaming45_60;
  prepareDataForLiveVaccStareaming45_60() {
    if (this.liveVaccChartStreaming45_60) {
      this.liveVaccChartStreaming45_60.destroy();
    }

    const ctx = $('#liveVacc45_60');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(52, 183, 82, 0.5)',
          borderColor: 'rgb(52, 183, 82)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 1.5,
          pointRadius: 2,
          fill: true,
          bezierCurve: false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display:false,
            beginAtZero: true,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 5,
              fontSize: 6,
              display:false,
              maxRotation: 0,
              minRotation: 0,
              fontColor: "#000000"
            },
            stacked: false,
            gridLines: {
              display: false,
              drawBorder: true,
              borderDash: [2, 4],
              zeroLineWidth: 0.05,
              zeroLineColor: '#000000'
            },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly:false,
            // beginAtZero: true,
            gridLines: {
              display:false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly:false,
              userCallback: function(value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreaming45_60 = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreaming45_60.update();
  }

  liveVaccChartStreamingabove_60;
  prepareDataForLiveVaccStareamingabove_60() {
    if (this.liveVaccChartStreamingabove_60) {
      this.liveVaccChartStreamingabove_60.destroy();
    }

    const ctx = $('#liveVaccabove_60');

    const format = this.numberFormatPipe;
    var vaccConfig = {
      type: 'line',
      data: {
        datasets: [{
          type: 'line',
          backgroundColor: 'rgb(94, 190, 93, 0.3)',
          borderColor: 'rgb(94, 190, 93)',
          borderWidth: 2,
          pointBackgroundColor: "rgb(94, 190, 93)",
          pointBorderWidth: 1.5,
          pointRadius: 1.5,
          fill: true,
          bezierCurve : false,
          data: 0,
        }]
      },
      options: {
        borderRadius: 50,
        tooltips: {
          enabled: true,
          mode: 'label',
          intersect: false,
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return '';
            },
            label: function (tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.datasetIndex] || '';


              if (label) {
                // label = moment(label).format('h:mm:ss a')
                label += ' | ';
              }

              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        legend: {
          display: false,
          boxWidth: 0,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 0,
            padding: 5,
            fontSize: 10,
          }
        },
        responsive: true,
        scales: {
          showScale: false,
          xAxes: [{
            // type: 'time',
            // time: {
            //   displayFormats: {
            //     second: 'h:mm:ss a'
            //   }
            // },
            display:false,
            // beginAtZero: true,
            // ticks: {
            //   autoSkip: true,
            //   maxTicksLimit: 5,
            //   fontSize: 6,
            //   display:false,
            //   maxRotation: 0,
            //   minRotation: 0,
            //   fontColor: "#000000"
            // },
            // stacked: false,
            // gridLines: {
            //   display: false,
            //   drawBorder: true,
            //   borderDash: [2, 4],
            //   zeroLineWidth: 0.05,
            //   zeroLineColor: '#000000'
            // },
          }],
          yAxes: [{
            // stacked: false,
            // barPercentage: 0.35,
            dispaly:false,
            // beginAtZero: true,
            gridLines: {
              display:false,
            },
            scaleShowLabels: false,
            ticks: {
              dispaly:false,
              userCallback: function(value, index, values) {
                return "";
              }
            }
          }]
        }


      }
    };

    this.liveVaccChartStreamingabove_60 = new Chart(ctx, vaccConfig);
    this.liveVaccChartStreamingabove_60.update();
  }


  prevsDataAge = {};
  updateCountTotalVaccAge = {'12_14': 0, '15_17': 0, '18_44': 0, '45_60': 0, 'above_60': 0};
  async updateDataAge() {
    const channelName = `covid_vaccination_bifurcation`;
    this.webSocket.listenAgeSocket(channelName).subscribe((data:any) => {
      let vacc_total_12_14 = data['vaccination_12_14_total'];
      let vacc_total_15_17 = data['vaccination_15_17_total'];
      let vacc_total_18_44 = data['vaccination_18_44_precaution_dose'] + data['vaccination_45_60_precaution_dose'];
      let vacc_total_45_60 = data['vaccination_above_60_precaution_dose'];
      // let vacc_total_above_60 = data['vaccination_above_60_total'];
      let label = moment(new Date()).format('HH:mm:ss');
      this.liveVaccChartStreaming12_14.data.labels.push(label);
      this.liveVaccChartStreaming15_17.data.labels.push(label);
      this.liveVaccChartStreaming18_44.data.labels.push(label);
      this.liveVaccChartStreaming45_60.data.labels.push(label);
      // this.liveVaccChartStreamingabove_60.data.labels.push(label);

      //12-14
      this.liveVaccChartStreaming12_14.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsDataAge['12_14']) {
            diff = vacc_total_12_14 - this.prevsDataAge['12_14']
          }
          this.prevsDataAge['12_14'] = vacc_total_12_14;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsDataAge['12_14']) {
            diff = vacc_total_12_14 - this.prevsDataAge['12_14']
          }
          this.prevsDataAge['12_14'] = vacc_total_12_14;
          dataset.data.push(diff)
        }
      });

      if (this.updateCountTotalVaccAge['12_14'] > this.numberOfElements) {
        this.liveVaccChartStreaming12_14.data.labels.shift();
        this.liveVaccChartStreaming12_14.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVaccAge['12_14']++;
      }
      this.liveVaccChartStreaming12_14.update();
      this.liveVaccChartStreaming12_14 = this.liveVaccChartStreaming12_14;

      //15-17
      this.liveVaccChartStreaming15_17.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsDataAge['15_17']) {
            diff = vacc_total_15_17 - this.prevsDataAge['15_17']
          }
          this.prevsDataAge['15_17'] = vacc_total_15_17;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsDataAge['15_17']) {
            diff = vacc_total_15_17 - this.prevsDataAge['15_17']
          }
          this.prevsDataAge['15_17'] = vacc_total_15_17;
          dataset.data.push(diff)
        }
      });

      if (this.updateCountTotalVaccAge['15_17'] > this.numberOfElements) {
        this.liveVaccChartStreaming15_17.data.labels.shift();
        this.liveVaccChartStreaming15_17.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVaccAge['15_17']++;
      }
      this.liveVaccChartStreaming15_17.update();
      this.liveVaccChartStreaming15_17 = this.liveVaccChartStreaming15_17;

      //18-44
      this.liveVaccChartStreaming18_44.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsDataAge['18_44']) {
            diff = vacc_total_18_44 - this.prevsDataAge['18_44']
          }
          this.prevsDataAge['18_44'] = vacc_total_18_44;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsDataAge['18_44']) {
            diff = vacc_total_18_44 - this.prevsDataAge['18_44']
          }
          this.prevsDataAge['18_44'] = vacc_total_18_44;
          dataset.data.push(diff)
        }
      });

      if (this.updateCountTotalVaccAge['18_44'] > this.numberOfElements) {
        this.liveVaccChartStreaming18_44.data.labels.shift();
        this.liveVaccChartStreaming18_44.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVaccAge['18_44']++;
      }
      this.liveVaccChartStreaming18_44.update();
      this.liveVaccChartStreaming18_44 = this.liveVaccChartStreaming18_44;


      //45-60
      this.liveVaccChartStreaming45_60.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsDataAge['45_60']) {
            diff = vacc_total_45_60 - this.prevsDataAge['45_60']
          }
          this.prevsDataAge['45_60'] = vacc_total_45_60;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsDataAge['45_60']) {
            diff = vacc_total_45_60 - this.prevsDataAge['45_60']
          }
          this.prevsDataAge['45_60'] = vacc_total_45_60;
          dataset.data.push(diff)
        }
      });

      if (this.updateCountTotalVaccAge['45_60'] > this.numberOfElements) {
        this.liveVaccChartStreaming45_60.data.labels.shift();
        this.liveVaccChartStreaming45_60.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVaccAge['45_60']++;
      }
      this.liveVaccChartStreaming45_60.update();
      this.liveVaccChartStreaming45_60 = this.liveVaccChartStreaming45_60;

      //above-60
      /*this.liveVaccChartStreamingabove_60.data.datasets.forEach((dataset) => {
        if (typeof dataset.data == 'number') {
          let diff = 0;
          if (this.prevsDataAge['above_60']) {
            diff = vacc_total_above_60 - this.prevsDataAge['above_60']
          }
          this.prevsDataAge['above_60'] = vacc_total_above_60;
          dataset.data = [diff];
        } else {
          let diff = 0;
          if (this.prevsDataAge['above_60']) {
            diff = vacc_total_above_60 - this.prevsDataAge['above_60']
          }
          this.prevsDataAge['above_60'] = vacc_total_above_60;
          dataset.data.push(diff)
        }
      });

      if (this.updateCountTotalVaccAge['above_60'] > this.numberOfElements) {
        this.liveVaccChartStreamingabove_60.data.labels.shift();
        this.liveVaccChartStreamingabove_60.data.datasets[0].data.shift();
      } else {
        this.updateCountTotalVaccAge['above_60']++;
      }
      this.liveVaccChartStreamingabove_60.update();
      this.liveVaccChartStreamingabove_60 = this.liveVaccChartStreamingabove_60; */
    });
  }

  loadIndiadata(){
    this.state_id = "";
    this.district_id = "";
    this.getDashboardData('','');
    this.getVacChartData('');
  }

}
